// user.model.ts

import { Injectable } from '@angular/core';
import { DeviceInterface } from '../interfaces/device-interface';
import { SuperLikeInterface } from '../interfaces/superLike-interface';
import { CoordinatesInterface } from '../interfaces/coordinates-interface';
import { ConfigInterface } from '../interfaces/config-interface';
import { MatchesInterface } from '../interfaces/matches-interface';
@Injectable({
  providedIn: 'root',
})
export class UserModel {
  email?: string;
  firstName?: string;
  lastName?: string;
  facebookId?: string;
  facebookAccessToken?: string;
  picture0?: any;
  wasOnHibernate?: boolean;
  hash?: string;
  device?: any;
  usingTeleportation?: boolean = false;
  filename: any;

  distanceUnit?: string;
  about?: string;

  language?: string;
  tempValidationCodeCreated?: string;
  lastSeenReal?: {
    $date: string;
  };
  termsAcceptedOn?: string;
  showAvocadoClubIndicator?: boolean;
  ageFilter?: {
    lower: number;
    upper: number;
  };
  _etag?: {
    $oid: string;
  };
  needsEmailValidation?: boolean;
  lastSeenLikedByQuant?: number;
  coins?: number;
  gender2?: string;
  distanceFilter?: number;
  matches?: MatchesInterface[];

  referralEmail?: string;
  seenTutorial?: boolean;
  lastSeenOn?: {
    $date: string;
  };
  receivedCoins?: boolean;
  _id?: {
    $oid: string;
  };

  interest2?: string[];

  paginationStarted?: {
    $date: string;
  };
  city?: string;
  excludedLikedBy?: number;
  dietFilter?: string[];
  likedSouls?: {
    $oid: string;
  }[];
  diet?: string;

  deletedLikes?: number;
  likedBySouls?: {
    $oid: string;
  }[];
  logoutOn?: {
    $date: string;
  };
  processedInitialReferral?: boolean;
  superLikedBySouls?: SuperLikeInterface[];
  referralUserId?: string;
  token?: string;
  facebookAccessTokenExpiresIn?: string;
  location?: CoordinatesInterface;
  newLikes?: boolean;
  config?: ConfigInterface;
  age?: number;


  // Method to set values for the user
  setValues(userValues: {

    email?: string;
    firstName?: string;
    lastName?: string;
    facebookId?: string;
    facebookAccessToken?: string;
    picture0?: string;
    wasOnHibernate?: boolean;
    hash?: string;
    device?: DeviceInterface;
    usingTeleportation?: boolean;

    distanceUnit?: string;
    about?: string;
    language?: string;
    tempValidationCodeCreated?: string;
    lastSeenReal?: {
      $date: string;
    };
    termsAcceptedOn?: string;
    showAvocadoClubIndicator?: boolean;
    ageFilter?: {
      lower: number;
      upper: number;
    };
    _etag?: {
      $oid: string;
    };
    needsEmailValidation?: boolean;
    lastSeenLikedByQuant?: number;
    coins?: number;
    gender2?: string;
    distanceFilter?: number;
    matches?: MatchesInterface[];

    referralEmail?: string;
    seenTutorial?: boolean;
    lastSeenOn?: {
      $date: string;
    };
    receivedCoins?: boolean;
    _id?: {
      $oid: string;
    };

    interest2?: string[];

    paginationStarted?: {
      $date: string;
    };
    city?: string;
    excludedLikedBy?: number;
    dietFilter?: string[];
    likedSouls?: {
      $oid: string;
    }[];
    diet?: string;

    deletedLikes?: number;
    likedBySouls?: {
      $oid: string;
    }[];
    logoutOn?: {
      $date: string;
    };
    processedInitialReferral?: boolean;
    superLikedBySouls?: SuperLikeInterface[];
    referralUserId?: string;
    token?: string;
    facebookAccessTokenExpiresIn?: string;
    location?: CoordinatesInterface;
    newLikes?: boolean;
    config?: ConfigInterface;
    age?: number;


  }): void {
    this.email = userValues.email !== undefined ? userValues.email : this.email;
    this.firstName = userValues.firstName !== undefined ? userValues.firstName : this.firstName;
    this.lastName = userValues.lastName !== undefined ? userValues.lastName : this.lastName;
    this.facebookId = userValues.facebookId !== undefined ? userValues.facebookId : this.facebookId;
    this.facebookAccessToken = userValues.facebookAccessToken !== undefined ? userValues.facebookAccessToken : this.facebookAccessToken;
    this.picture0 = userValues.picture0 !== undefined ? userValues.picture0 : this.picture0;
    this.wasOnHibernate = userValues.wasOnHibernate !== undefined ? userValues.wasOnHibernate : this.wasOnHibernate;
    this.location = userValues.location !== undefined ? userValues.location : this.location;
    this.hash = userValues.hash !== undefined ? userValues.hash : this.hash;
    this.device = userValues.device !== undefined ? userValues.device : this.device;
    this.usingTeleportation = userValues.usingTeleportation !== undefined ? userValues.usingTeleportation : this.usingTeleportation;

    this.distanceUnit = userValues.distanceUnit !== undefined ? userValues.distanceUnit : this.distanceUnit;
    this.about = userValues.about !== undefined ? userValues.about : this.about;
    this.language = userValues.language !== undefined ? userValues.language : this.language;
    this.tempValidationCodeCreated = userValues.tempValidationCodeCreated !== undefined ? userValues.tempValidationCodeCreated : this.tempValidationCodeCreated;
    this.lastSeenReal = userValues.lastSeenReal !== undefined ? userValues.lastSeenReal : this.lastSeenReal;
    this.termsAcceptedOn = userValues.termsAcceptedOn !== undefined ? userValues.termsAcceptedOn : this.termsAcceptedOn;
    this.showAvocadoClubIndicator = userValues.showAvocadoClubIndicator !== undefined ? userValues.showAvocadoClubIndicator : this.showAvocadoClubIndicator;
    this.ageFilter = userValues.ageFilter !== undefined ? userValues.ageFilter : this.ageFilter;
    this._etag = userValues._etag !== undefined ? userValues._etag : this._etag;
    this.needsEmailValidation = userValues.needsEmailValidation !== undefined ? userValues.needsEmailValidation : this.needsEmailValidation;
    this.lastSeenLikedByQuant = userValues.lastSeenLikedByQuant !== undefined ? userValues.lastSeenLikedByQuant : this.lastSeenLikedByQuant;
    this.coins = userValues.coins !== undefined ? userValues.coins : this.coins;
    this.gender2 = userValues.gender2 !== undefined ? userValues.gender2 : this.gender2;
    this.distanceFilter = userValues.distanceFilter !== undefined ? userValues.distanceFilter : this.distanceFilter;
    this.matches = userValues.matches !== undefined ? userValues.matches : this.matches;
    this.referralEmail = userValues.referralEmail !== undefined ? userValues.referralEmail : this.referralEmail;
    this.seenTutorial = userValues.seenTutorial !== undefined ? userValues.seenTutorial : this.seenTutorial;
    this.lastSeenOn = userValues.lastSeenOn !== undefined ? userValues.lastSeenOn : this.lastSeenOn;
    this.receivedCoins = userValues.receivedCoins !== undefined ? userValues.receivedCoins : this.receivedCoins;
    this._id = userValues._id !== undefined ? userValues._id : this._id;
    this.interest2 = userValues.interest2 !== undefined ? userValues.interest2 : this.interest2;
    this.paginationStarted = userValues.paginationStarted !== undefined ? userValues.paginationStarted : this.paginationStarted;
    this.city = userValues.city !== undefined ? userValues.city : this.city;
    this.excludedLikedBy = userValues.excludedLikedBy !== undefined ? userValues.excludedLikedBy : this.excludedLikedBy;
    this.dietFilter = userValues.dietFilter !== undefined ? userValues.dietFilter : this.dietFilter;
    this.likedSouls = userValues.likedSouls !== undefined ? userValues.likedSouls : this.likedSouls;
    this.diet = userValues.diet !== undefined ? userValues.diet : this.diet;
    this.deletedLikes = userValues.deletedLikes !== undefined ? userValues.deletedLikes : this.deletedLikes;
    this.likedBySouls = userValues.likedBySouls !== undefined ? userValues.likedBySouls : this.likedBySouls;
    this.logoutOn = userValues.logoutOn !== undefined ? userValues.logoutOn : this.logoutOn;
    this.processedInitialReferral = userValues.processedInitialReferral !== undefined ? userValues.processedInitialReferral : this.processedInitialReferral;
    this.superLikedBySouls = userValues.superLikedBySouls !== undefined ? userValues.superLikedBySouls : this.superLikedBySouls;
    this.referralUserId = userValues.referralUserId !== undefined ? userValues.referralUserId : this.referralUserId;
    this.token = userValues.token !== undefined ? userValues.token : this.token;
    this.facebookAccessTokenExpiresIn = userValues.facebookAccessTokenExpiresIn !== undefined ? userValues.facebookAccessTokenExpiresIn : this.facebookAccessTokenExpiresIn;
    this.location = userValues.location !== undefined ? userValues.location : this.location;
    this.newLikes = userValues.newLikes !== undefined ? userValues.newLikes : this.newLikes;
    this.config = userValues.config !== undefined ? userValues.config : this.config;
    this.age = userValues.age !== undefined ? userValues.age : this.age;



  }

  // Method to get all user values
  getValues() {
    return {
      email: this.email,
      firstName: this.firstName,
      lastName: this.lastName,
      facebookId: this.facebookId,
      facebookAccessToken: this.facebookAccessToken,
      picture0: this.picture0,
      wasOnHibernate: this.wasOnHibernate,
      location: this.location,
      hash: this.hash,
      device: this.device,
      usingTeleportation: this.usingTeleportation,

      distanceUnit: this.distanceUnit,
      about: this.about,
      language: this.language,
      tempValidationCodeCreated: this.tempValidationCodeCreated,
      lastSeenReal: this.lastSeenReal,
      termsAcceptedOn: this.termsAcceptedOn,
      showAvocadoClubIndicator: this.showAvocadoClubIndicator,
      ageFilter: this.ageFilter,
      _etag: this._etag,
      needsEmailValidation: this.needsEmailValidation,
      lastSeenLikedByQuant: this.lastSeenLikedByQuant,
      coins: this.coins,
      gender2: this.gender2,
      distanceFilter: this.distanceFilter,
      matches: this.matches,
      referralEmail: this.referralEmail,
      seenTutorial: this.seenTutorial,
      lastSeenOn: this.lastSeenOn,
      receivedCoins: this.receivedCoins,
      _id: this._id,
      interest2: this.interest2,
      paginationStarted: this.paginationStarted,
      city: this.city,
      excludedLikedBy: this.excludedLikedBy,
      dietFilter: this.dietFilter,
      likedSouls: this.likedSouls,
      diet: this.diet,
      deletedLikes: this.deletedLikes,
      likedBySouls: this.likedBySouls,
      logoutOn: this.logoutOn,
      processedInitialReferral: this.processedInitialReferral,
      superLikedBySouls: this.superLikedBySouls,
      referralUserId: this.referralUserId,
      token: this.token,
      facebookAccessTokenExpiresIn: this.facebookAccessTokenExpiresIn,
      newLikes: this.newLikes,
      config: this.config,
      age:this.age,

    }
  }
}

